import { Injectable } from '@angular/core';
import { HttpGeneralService, StockModuleSettingsParms } from '../shared';
import { EmrPatientParms, EmrPatHistory, EmrPatAllergy, EmrPatVitals, EmrFacePainRatingScale, EmrBurnChart } from './medical-recored.interfaces';
import { CONFIG } from '../shared/config';
import { ModalService } from '../blocks/modal/modal.service';
import { mergeMap } from 'rxjs/operators';
import { MedicalRepositoryService } from './medical-repository.service';

// medical 3 {compalins - finding - diagnois}
let emrComplainsUrl = CONFIG.baseUrls.EmrPatComplains;
let emrFindingUrl = CONFIG.baseUrls.EmrPatFinding;
let emrDiagnoisUrl = CONFIG.baseUrls.EmrPatDiagnosis;
let emrPatGlassCardUrl = CONFIG.baseUrls.EmrpatGlassCard;
let stockTransUrl = CONFIG.baseUrls.StockTrans;
// urls for medical scores api
let emrGlasgowComaScaleUrl = CONFIG.baseUrls.EmrPatGlasgowComaScale;
let emrBehavioralPainScaleUrl = CONFIG.baseUrls.EmrPatBehavioralPainScale;
let emrNonverbalPainScaleUrl = CONFIG.baseUrls.EmrPatNonverbalPainScale;
let emrFacePainScaleUrl = CONFIG.baseUrls.EmrPatFacePainScale;
let emrPlasticSurgeryUrl = CONFIG.baseUrls.EmrPlasticSurgery;
let emrBurnChartUrl = CONFIG.baseUrls.EmrBurnChart;

// url for history
let emrPatHistoryUrl = CONFIG.baseUrls.EmrPatHistory;
let emrPatAllergyUrl = CONFIG.baseUrls.EmrPatAllergy;
let emrPatVitalsUrl = CONFIG.baseUrls.EmrPatVitals;


@Injectable({
  providedIn: 'root'
})
export class MedicalControllerService {

  constructor
    (private _http: HttpGeneralService,
      private _medicalRepo: MedicalRepositoryService,
      private _modalService: ModalService) { }

  // medical main 4 { Diagnois - Complains - Findings - Glass Card }
  GetMedicalCompDiagFind(data: EmrPatientParms, type: 'COMP' | 'DIAG' | 'FIND' | 'GLASS') {
    let apiUrl: string = '';
    if (type == 'COMP') {
      apiUrl = `${emrComplainsUrl}/getEmrComplainsData`;
    } else if (type == 'FIND') {
      apiUrl = `${emrFindingUrl}/getEmrFindingsData`;
    } else if (type == 'DIAG') {
      apiUrl = `${emrDiagnoisUrl}/getEmrDiagnosisData`;
    } else {
      apiUrl = `${emrPatGlassCardUrl}/getEmrGlassCardsData`;
    }
    return this._http.post(data, apiUrl);
  }

  DeleteMedicalCompDiagFind(serial: number, type: 'COMP' | 'DIAG' | 'FIND' | 'GLASS') {
    let apiUrl = '';
    if (type == 'COMP') {
      apiUrl = `${emrComplainsUrl}`;
    } else if (type == 'FIND') {
      apiUrl = `${emrFindingUrl}`;
    } else if (type == 'DIAG') {
      apiUrl = `${emrDiagnoisUrl}`;
    } else {
      apiUrl = `${emrPatGlassCardUrl}`;
    }
    return this._http.delete(serial, apiUrl);
  }

  PostMedicalCompDiagFind<T>(emrData: T[], type: 'COMP' | 'DIAG' | 'FIND' | 'GLASS') {
    let apiUrl = '';
    if (type == 'COMP') {
      apiUrl = `${emrComplainsUrl}`;
    } else if (type == 'FIND') {
      apiUrl = `${emrFindingUrl}`;
    } else if (type == 'DIAG') {
      apiUrl = `${emrDiagnoisUrl}`;
    } else {
      apiUrl = `${emrPatGlassCardUrl}`;
    }
    return this._http.add<any>(emrData, apiUrl);
  }

  // medcial scores { nonverbal - behavior - glascoma}
  PostEmrMedicalScores<T>(medicalScores: T, type: 'GLASSCOMA' | 'BEHAVIOR' | 'NONVERBAL' | 'FACERATING' | 'EMRBURNCHART' | 'EMRPLASTICSURGERY') {
    let apiUrl: string = '';
    if (type == 'BEHAVIOR') {
      apiUrl = `${emrBehavioralPainScaleUrl}`;
    } else if (type == 'GLASSCOMA') {
      apiUrl = `${emrGlasgowComaScaleUrl}`;
    } else if (type == 'NONVERBAL') {
      apiUrl = `${emrNonverbalPainScaleUrl}`;
    } else if (type == 'FACERATING') {
      apiUrl = `${emrFacePainScaleUrl}`;
    } else if (type == 'EMRPLASTICSURGERY') {
      apiUrl = `${emrPlasticSurgeryUrl}`;

    }
    else {
      apiUrl = `${emrBurnChartUrl}`;
    }
    return this._http.add<T>(medicalScores, apiUrl);
  }

  GetEmrMedicalScores(data: EmrPatientParms, type: 'GLASSCOMA' | 'BEHAVIOR' | 'NONVERBAL' | 'FACERATING' | 'EMRBURNCHART') {
    let apiUrl: string = '';
    if (type == 'BEHAVIOR') {
      apiUrl = `${emrBehavioralPainScaleUrl}/getEmrBehavioralPainScalesData`;
    } else if (type == 'GLASSCOMA') {
      apiUrl = `${emrGlasgowComaScaleUrl}/getEmrGlasgowComaScalesData`;
    } else if (type == 'NONVERBAL') {
      apiUrl = `${emrNonverbalPainScaleUrl}/getEmrNonverbalPainScalesData`;
    }
    else if (type == 'FACERATING') {
      apiUrl = `${emrFacePainScaleUrl}/getFacePainScaleData`;
    }
    return this._http.post(data, apiUrl);
  }

  getEmrBurnChartData(visitSerial: number) {
    return this._http.getWith(`${emrFacePainScaleUrl}/getEmrBurnChartData/${visitSerial}`);
  }

  UpdateEmrPatFacePainScale(obj: EmrFacePainRatingScale) {
    return this._http.update<EmrFacePainRatingScale>(obj.serial, obj, `${emrFacePainScaleUrl}/updateFacePainScaleData`);

  }

  UpdateEmrBurnChart(obj: EmrBurnChart) {
    return this._http.post<EmrBurnChart>(obj, `${emrBurnChartUrl}/updateEmrBurnChart`);

  }

  DeleteEmrMedicalScores(serial: number, type: 'GLASSCOMA' | 'BEHAVIOR' | 'NONVERBAL' | 'FACERATING' | 'EMRBURNCHART' | 'EMRPLASTICSURGERY') {
    let apiUrl: string = '';
    if (type == 'BEHAVIOR') {
      apiUrl = `${emrBehavioralPainScaleUrl}`;
    } else if (type == 'GLASSCOMA') {
      apiUrl = `${emrGlasgowComaScaleUrl}`;
    } else if (type == 'NONVERBAL') {
      apiUrl = `${emrNonverbalPainScaleUrl}`;
    } else if (type == 'FACERATING') {
      apiUrl = `${emrFacePainScaleUrl}`;
    } else if (type == 'EMRPLASTICSURGERY') {
      apiUrl = `${emrPlasticSurgeryUrl}`;
    }
    else {
      apiUrl = `${emrBurnChartUrl}`;
    }
    return this._http.delete(serial, apiUrl);
  }

  //--------> Illness History Service Functions <--------\\
  addEmrPatHistory(emrPatHistory: EmrPatHistory) {
    return this._http.add<EmrPatHistory>(emrPatHistory, emrPatHistoryUrl);
  }

  addEmrPatHistoryList(emrPatHistory: EmrPatHistory[]) {
    return this._http.add<any>(emrPatHistory, `${emrPatHistoryUrl}/EmrPatHistoryList`);
  }
  getEmrPatHistory(id: number) {
    return this._http.get(id, emrPatHistoryUrl);
  }
  updateEmrPatHistory(emrPatHistory: EmrPatHistory) {
    return this._http.update<EmrPatHistory>(emrPatHistory.serial, emrPatHistory, emrPatHistoryUrl);
  }
  deleteEmrPatHistory(emrPatHistory: EmrPatHistory) {
    return this._http.delete(emrPatHistory.serial, emrPatHistoryUrl);
  }

  addEmrPatAllergy(emrPatAllergy: EmrPatAllergy[]) {
    return this._http.add<any>(emrPatAllergy, emrPatAllergyUrl)
  }

  getEmrPatAllergy(VisitCode: number) {
    return this._http.getWith(`${emrPatAllergyUrl}/getEmrPatAllergy/${VisitCode}`)
  }

  deleteEmrPatAllergy(emrPatAllergy: EmrPatAllergy) {
    return this._http.delete(emrPatAllergy.serial, `${emrPatAllergyUrl}`)
  }


  //----------- Vitals Service functions ------------//
  addEmrPatVitals(emrPatVitals: EmrPatVitals) {
    return this._http.add<EmrPatVitals>(emrPatVitals, emrPatVitalsUrl);
  }
  getEmrPatVitals(id: number) {
    return this._http.get(id, emrPatVitalsUrl);
  }
  getEmrPatVitalByList(emrPatVitals: EmrPatVitals) {
    return this._http.add(emrPatVitals, `${emrPatVitalsUrl}/GetEmrVitalList`);
  }
  getVitals(data: any) {
    return this._http.post(data, `${emrPatVitalsUrl}/GetVitals`);
  }
  updateEmrPatVitals(emrPatVitals: EmrPatVitals) {
    return this._http.update<EmrPatVitals>(emrPatVitals.serial, emrPatVitals, emrPatVitalsUrl);
  }
  deleteEmrPatVitals(emrPatVitals: EmrPatVitals) {
    return this._http.delete(emrPatVitals.serial, emrPatVitalsUrl);
  }
  getEmrVitalSigns(id: number) {
    return this._http.getWith(`${emrPatVitalsUrl}/GetEmrVitalSignsCharts/${id}`);
  }

  getEmrVitalSignsBySpecialityId(specialityId: number, visitType: number) {
    return this._http.getWith(`${emrPatVitalsUrl}/GetEmrVitalSignsBySpecialityId/${specialityId}/${visitType}`);
  }

  deleteVitals(itemData: EmrPatVitals, emrPatVitals?: EmrPatVitals[]) {
    this._modalService.activeDelMes(itemData.serial.toString(), itemData.serial.toString()).then(responseOK => {
      if (responseOK) {

        this.deleteEmrPatVitals(itemData)
          .pipe(mergeMap(data => this.getEmrPatVitals(itemData.visitSerial)))
          .subscribe(res => {
            emrPatVitals = res ? res.data : [];
            this._medicalRepo.VitalsData = emrPatVitals;
          });
      }
    });
    return emrPatVitals;

  }
  getModuleSettings(parms: StockModuleSettingsParms) {
    return this._http.add(parms, `${stockTransUrl}/GetStockModuleSettings`);
  }
  postBabyPainAssesssmentTools(EmrPainAssesssmentTools: any) {
    return this._http.add(EmrPainAssesssmentTools, `${emrBehavioralPainScaleUrl}/PostPainAssesssmentTools`);
  }

  deletePainAssesssmentTools(serial: number) {
    return this._http.delete(serial, `${emrBehavioralPainScaleUrl}/DeletePainAssesssmentTools`);
  }
  getEmrBehavioralPainScaleSearch(SearchData: any) {
    return this._http.post(SearchData, `${emrBehavioralPainScaleUrl}/getEmrBehavioralPainScaleSearch`);
  }
  postEmrReassessmentPain(item: any) {
    return this._http.post(item, `${emrBehavioralPainScaleUrl}/PostEmrReassessmentPain`);
  }
  deleteEmrReassessmentPain(serial: number) {
    return this._http.delete(serial, `${emrBehavioralPainScaleUrl}/DeleteEmrReassessmentPain`);
  }
}
